var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"alt":"","src":require("../../assets/img/no-oder.png")}}),_c('p',[_vm._v("暂无售后订单")])])
}]

export { render, staticRenderFns }